import Vue from 'vue'
import Router from 'vue-router'
import IndexLogin from '@/components/index/login'
import IndexRegist from '@/components/index/regist'
import IndexAnswer from '@/components/index/answer'
import IndexIndex from '@/components/index/index'
import IndexSign from '@/components/index/sign'
import UserDetail from '@/components/user/detail'
import UserUsed from '@/components/user/used'
import UserCoupons from '@/components/user/coupons'
import UserPassword from '@/components/user/password'
import InterviewList from '@/components/interview/list'
import InterviewRecord from '@/components/interview/record'
import NotFound from '@/components/index/notfound'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'IndexIndex',
      component: IndexIndex,
      meta: {
        title:'安蓝航运智能助手',
        navShow:false,
        index:1
      }
    },
    {
      path: '/index/login',
      name: 'IndexLogin',
      component: IndexLogin,
      meta: {
        title:'用户登录',
        navShow:false,
        index:5
      }
    },
    {
      path: '/index/regist',
      name: 'IndexRegist',
      component: IndexRegist,
      meta: {
        title:'用户注册',
        navShow:false,
        index:6
      }
    },
    {
      path: '/index/answer',
      name: 'IndexAnswer',
      component: IndexAnswer,
      meta: {
        title:'智能小蓝',
        navShow:true,
        navPath:'/',
        index:2
      }
    },
    {
      path: '/index/sign',
      name: 'IndexSign',
      component: IndexSign,
      meta: {
        title:'每周签到',
        navShow:true,
        index:5
      }
    },
    {
      path: '/interview/list',
      name: 'InterviewList',
      component: InterviewList,
      meta: {
        title:'检查历史记录',
        navShow:true,
        navPath:'/index/answer',
        index:52
      }
    },
    {
      path: '/interview/record',
      name: 'InterviewRecord',
      component: InterviewRecord,
      meta: {
        title:'增改检查记录',
        navShow:true,
        navPath:'/interview/list',
        index:53
      }
    },
    {
      path: '/user/detail',
      name: 'UserDetail',
      component: UserDetail,
      meta: {
        title:'我的信息',
        navShow:true,
        navPath:'/index/answer',
        index:36
      }
    },
    {
      path: '/user/used',
      name: 'UserUsed',
      component: UserUsed,
      meta: {
        title:'服务记录',
        navShow:true,
        navPath:'/index/answer',
        index:39
      }
    },
    {
      path: '/user/coupons',
      name: 'UserCoupons',
      component: UserCoupons,
      meta: {
        title:'已购项目',
        navShow:true,
        navPath:'/index/answer',
        index:38
      }
    },
    {
      path: '/user/password',
      name: 'UserPassword',
      component: UserPassword,
      meta: {
        title:'修改密码',
        navShow:true,
        navPath:'/index/answer',
        index:37
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title:'Not Found',
        navShow:false,
        index:999
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js